import React from 'react';
import PropTypes from 'prop-types';
export const AvatarIcon = props => (
	<svg
		className={props.className}
		xmlns='http://www.w3.org/2000/svg'
		width={props.width}
		height={props.height}
		viewBox='0 0 25 24'
		fill='none'
	>
		<g>
			<path
				d='M12.7029 11.8001L11.2929 13.2101C10.5129 13.9901 10.5129 15.2601 11.2929 16.0401C12.0729 16.8201 13.3429 16.8201 14.1229 16.0401L16.3429 13.8201C17.092 13.0688 17.5127 12.0511 17.5127 10.9901C17.5127 9.92908 17.092 8.91138 16.3429 8.16007C15.5916 7.41092 14.5739 6.99023 13.5129 6.99023C12.4519 6.99023 11.4342 7.41092 10.6829 8.16007L8.26289 10.5801C7.94426 10.8984 7.69149 11.2765 7.51903 11.6926C7.34658 12.1087 7.25781 12.5547 7.25781 13.0051C7.25781 13.4555 7.34658 13.9015 7.51903 14.3176C7.69149 14.7337 7.94426 15.1117 8.26289 15.4301'
				stroke={props.color}
				strokeWidth='1.5'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
			<path
				d='M9.5 22H15.5C20.5 22 22.5 20 22.5 15V9C22.5 4 20.5 2 15.5 2H9.5C4.5 2 2.5 4 2.5 9V15C2.5 20 4.5 22 9.5 22Z'
				stroke={props.color}
				strokeWidth='1.5'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
		</g>
	</svg>
);

AvatarIcon.propTypes={
	className:PropTypes.any,
	width:PropTypes.any,
	height:PropTypes.any,
	color:PropTypes.any
};
